export const LEAD_FORM = '[LeadForm]';
